// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WorkItemCommentListResultModel from '../../model/work-item-comment-list-result-model';
import WorkItemCommentListResultDTO from '../dto/work-item-comment-list-result-dto';
import dtoSchema from '../schemas/work-item-comment-list-result-schema';
import WorkItemCommentModel from '../../model/work-item-comment-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WorkItemCommentListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WorkItemCommentListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WorkItemCommentModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: WorkItemCommentModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<WorkItemCommentListResultDTO>): WorkItemCommentListResultModel;
  static toModel(dto: DeepPartial<WorkItemCommentListResultDTO> | undefined | null): WorkItemCommentListResultModel | undefined;
  static toModel(dto: DeepPartial<WorkItemCommentListResultDTO> | undefined | null): WorkItemCommentListResultModel | undefined {
    return dto ? new WorkItemCommentListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WorkItemCommentListResultModel> | WorkItemCommentListResultModel): WorkItemCommentListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as WorkItemCommentListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WorkItemCommentListResultModel, can not map to WorkItemCommentListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
